export enum OnboardingEventMessageType {
  exit = "ONBOARDING_EXIT",
  success = "ONBOARDING_SUCCESS",
  error = "ONBOARDING_ERROR",
}
